import axios from 'axios';
import useUserToken from '../context/userTokenContext';

const baseURL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
    // ? 'http://localhost:3000'
    ? process.env.REACT_APP_PRODUCTION_URL
    : '/';

const backend = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
        'apikey': process.env.REACT_APP_API_KEY
    },
});

// Interceptor to set Authorization header dynamically
backend.interceptors.request.use((config) => {
    const userToken = useUserToken.getState().userToken; // Get current userToken
    if (userToken) {
        config.headers.Authorization = `Bearer ${userToken}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

async function login(username, password) {
    try {
        const response = await backend.post('/users/login', {
            username,
            password,
        });
        return { status: response.status, data: response.data, error: null };
    } catch (error) {
        const status = error.response?.status || 'Network Error';
        const message = error.response?.data?.message || error.message || 'Unknown error';

        console.error(`Login failed - Status: ${status}, Message: ${message}`);

        // Return a consistent structure for errors
        return { status, data: null, error: message };
    }
}

// async function getCorrespondingGatewaysRemake() {
//     try {
//         const response = await backend.get('/mobile/gatewayCounters');
//         // console.log(response)
//         return { status: response.status, data: response.data };
//     } catch (error) {
//         if (error.response && error.response.status === 404) {
//             return { status: error.response.status, message: error.response.message, data: null };
//         } else {
//             console.error('Login error:', error.response ? error.response.data : error.message);
//         }
//         throw error; // re-throw the error for handling in the component
//     }
// }

// async function getDevicesCounters() {
//     try {
//         const response = await backend.get('/mobile/deviceCounters');
//         // console.log(response)
//         return { status: response.status, data: response.data };
//     } catch (error) {
//         if (error.response && error.response.status === 404) {
//             return { status: error.response.status, message: error.response.message, data: null };
//         } else {
//             console.error('Login error:', error.response ? error.response.data : error.message);
//         }
//         throw error; // re-throw the error for handling in the component
//     }
// }

async function getGatewaysCounters() {
    try {
        const response = await backend.get('/mobile/gatewayCounters');
        return { status: response.status, data: response.data };
    } catch (error) {
        // if (error.response && error.response.status === 401) {
        //     window.location.href = '/';
        // }
        // if (error.response && error.response.status === 403) {
        //     window.location.href = '/';
        // }
        // const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred";
        // const errorStatus = error.response?.status || 500;
        // throw new Error(`Error ${errorStatus}: ${errorMessage}`);
        checkTokenError(error);
    }
}

// async function getGateways() {
//     try {
//         const response = await backend.get('/mobile/gatewayStatisticsFromDB');
//         // console.log(response)
//         return { status: response.status, data: response.data };
//     } catch (error) {
//         if (error.response && error.response.status === 404) {
//             return { status: error.response.status, data: null };
//         } else {
//             console.error('Login error:', error.response ? error.response.data : error.message);
//         }
//         throw error; // re-throw the error for handling in the component
//     }
// }

async function getGateways() {
    try {
        const response = await backend.get('/mobile/gatewayStatisticsFromDB');
        return { status: response.status, data: response.data };
    } catch (error) {
        // if (error.response && error.response.status === 401) {
        //     window.location.href = '/';
        // }
        // const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred";
        // const errorStatus = error.response?.status || 500;
        // throw new Error(`Error ${errorStatus}: ${errorMessage}`);
        checkTokenError(error);
    }
}

async function getGateway(uid, server) {
    try {
        const response = await backend.get(`/mobile/gateways/${uid}/${server}`);
        console.log(response)
        return { data: response.data };
    } catch (error) {
        // if (error.response && error.response.status === 404) {
        //     return { status: error.response.status, data: null };
        // } else if (error.response && error.response.status === 401) {
        //     window.location.href = '/';
        // }
        // else {
        //     console.error('Login error:', error.response ? error.response.data : error.message);
        // }
        // throw error; // re-throw the error for handling in the component
        checkTokenError(error);
    }
}

async function getGatewayStatistics(id) {
    try {
        const response = await backend.get(`/web/gatewayStatisticsTest/${id}`);
        console.log("Gateway Statistics Data:", response.data);
        return { data: response.data };
    } catch (error) {
        // if (error.response && error.response.status === 404) {
        //     return { status: error.response.status, data: null };
        // } else if (error.response && error.response.status === 401) {
        //     window.location.href = '/';
        // }
        // else {
        //     console.error('Error fetching statistics:', error.response ? error.response.data : error.message);
        // }
        // throw error;
        checkTokenError(error);
    }
}

async function getDevicesCounters() {
    try {
        const response = await backend.get('/mobile/deviceCounters');
        return { status: response.status, data: response.data };
    } catch (error) {
        // if (error.response && error.response.status === 401) {
        //     window.location.href = '/';
        // }
        // if (error.response && error.response.status === 403) {
        //     window.location.href = '/';
        // }
        // const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred";
        // const errorStatus = error.response?.status || 500;
        // throw new Error(`Error ${errorStatus}: ${errorMessage}`);
        checkTokenError(error);
    }
}

async function getDevices(filteredLocation) {
    try {

        // console.log('inside getDevices')
        // console.log(filteredLocation)
        // console.log(typeof filteredLocation)
        // console.log(`/web/devicesTest/?location="${filteredLocation}"`)
        const response = await backend.get(`/web/devicesTest/?location=${filteredLocation}`);
        return { status: response.status, data: response.data };
    } catch (error) {
        // if (error.response && error.response.status === 401) {
        //     window.location.href = '/';
        // }
        // const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred";
        // const errorStatus = error.response?.status || 500;
        // throw new Error(`Error ${errorStatus}: ${errorMessage}`);
        checkTokenError(error);
    }
}

async function getDevice(deveui, server) {
    try {
        const response = await backend.get(`/web/devices/${deveui}/${server}`);
        console.log(response)
        return { data: response.data };
    } catch (error) {
        if (error.response && error.response.status === 404) {
            return { status: error.response.status, data: null };
        } else {
            checkTokenError(error);
        }
        // else if (error.response && error.response.status === 401) {
        //     window.location.href = '/';
        // }
        // else {
        //     console.error('Login error:', error.response ? error.response.data : error.message);
        // }
        // throw error; // re-throw the error for handling in the component

    }
}

async function getLocationsData() {
    try {
        const response = await backend.get('/mobile/getLocationsData');
        return { status: response.status, data: response.data };
    } catch (error) {
        checkTokenError(error);
    }
}

async function getAvailableLocations() {
    try {
        const response = await backend.get('/mobile/getAvailableLocations');
        return { status: response.status, data: response.data };
    } catch (error) {
        checkTokenError(error);
    }
}

function checkTokenError(error) {
    if (error.response && error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('locationsData');
        localStorage.removeItem('searchList');
        window.location.href = '/';
    }
    if (error.response && error.response.status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('locationsData');
        localStorage.removeItem('searchList');
        window.location.href = '/';
    }
    const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred";
    const errorStatus = error.response?.status || 500;
    throw new Error(`Error ${errorStatus}: ${errorMessage}`);
}

export {
    login,

    // Gateways
    getGatewaysCounters,
    getGateways,
    getGateway,
    getGatewayStatistics,

    // Devices
    getDevicesCounters,
    getDevices,
    getDevice,

    // Locations
    getLocationsData,
    getAvailableLocations
};